import Swiper from "swiper/bundle";

export default function setup() {
    const swiper = new Swiper(".mySwiper", {
        //freeMode: true,
        //watchSlidesProgress: true,
        loop: true,
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 4,
                spaceBetween: 10
            },            
        }, 
        navigation: {
            nextEl: ".swiper-button-next-main",
            prevEl: ".swiper-button-prev-main",
        },
    });
    const swiper2 = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper,
        },
        loop: true,        
    });

    //$('.gallary-action-share').hover(function () {
    //    $('.shared-popup').addClass('shared-popup-active');
    //}, function () {
    //    if (!$('.shared-popup').find('input:focus').length) {
    //        $('.shared-popup').removeClass('shared-popup-active');
    //    }
    //});

    // Replace the hover code with this click handler
    document.querySelectorAll('.gallary-action-share').forEach(button => {
        button.addEventListener('click', function (e) {
            e.stopPropagation();
            const popup = this.querySelector('.shared-popup');
            popup.classList.toggle('shared-popup-active');
        });
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.gallary-action-share')) {
            document.querySelectorAll('.shared-popup').forEach(popup => {
                popup.classList.remove('shared-popup-active');
            });
        }
    });

    // Close when clicking inside popup (optional)
    document.querySelectorAll('.shared-popup').forEach(popup => {
        popup.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    });
}